import request from '@/networks/request.js'
export default {
	refresh(context) {
		request.request({
			url: '/login/getShop',
			data: {},
			method: 'get'
		}).then(data => {
			return new Promise((resolve, reject) => {
				context.commit('refresh', data);
			});
		}).catch(err => {
			console.log('刷新数据失败')
		});
	}

}
